import camelCase from '../lib/camelCase';
import Immutable from 'immutable';
import qs from 'qs';

export function login(api, data) {
    return api.post(api.url('auth/login'), data.toJSON(), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(camelCase(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export function logout(api) {
    return api.get(api.url('auth/logout'), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(camelCase(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export function register(api, data) {
    return api.post(api.url('auth/register'), data.toJSON(), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(camelCase(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export function activateTenant(api) {
    return api.post(api.url('auth/activate-tenant'), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        transformRequest(payload) {
            return qs.stringify(payload);
        },
        transformResponse(json) {
            const response = JSON.parse(json);
            if (response.payload) {
                return response && response.payload
                    ? Immutable.fromJS(camelCase(response.payload))
                    : response;
            }
            return response
                ? Immutable.fromJS(camelCase(response))
                : response;
        },
    });
}

export default {
    login,
    logout,
    register,
    activateTenant,
};
